import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { FileHandlerService } from "@shared/Services/fileHandler.service";

import { OptionsType } from "@salud/shared/Types/options-type.interface";

import { HistoricoCarnetRepository } from "../Repositories/historico-carnet.repository";
import { HistoricoCarnet, HistoricoCarnetEmail, HistoricoCarnetFilter } from "../Types/interfaces/HistoricoCarnet.interface";

@Injectable({
  providedIn: "root",
})
export class HistoricoCarnetService {
  constructor(private historicoCarnetRepository: HistoricoCarnetRepository, private fileHandlerService: FileHandlerService) {}

  public getHistoricoCarnets(filter: HistoricoCarnetFilter): Observable<HistoricoCarnet[]> {
    return this.historicoCarnetRepository.getHistoricoCarnets(filter);
  }

  public getPlanes(): Observable<OptionsType<string, string>[]> {
    return this.historicoCarnetRepository.getPlanes();
  }

  public printCarnet(identificationNumber: string, contractNumber: string): void {
    this.historicoCarnetRepository
      .printCarnet(identificationNumber, contractNumber)
      .pipe(first())
      .subscribe(this.fileHandlerService.openPdfInNewTab);
  }

  public sendEmailNotification(request: HistoricoCarnetEmail): Observable<ShareMessageResponse> {
    return this.historicoCarnetRepository.sendEmailNotification(request);
  }
}
